module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "click-out",
      rawName: "v-click-out",
      value: (_vm.hide),
      expression: "hide"
    }],
    staticClass: "btn-group dropdown",
    class: {
      open: _vm.open
    }
  }, [_c('span', {
    staticClass: "btn btn-info btn-xs"
  }, [_vm._v("Opções")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info btn-xs dropdown-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown",
      "tabindex": "1",
      "aria-expanded": "false"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.toggle($event)
      }
    }
  }, [_c('span', {
    staticClass: "caret"
  }), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle Dropdown")])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu dropdown-menu-right no-padder"
  }, [_c('li', [_c('a', {
    on: {
      "click": _vm.forcarExecucaoTask
    }
  }, [_c('i', {
    staticClass: "fa fa-flash"
  }), _vm._v(" Forçar Execução")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "text-danger",
    on: {
      "click": _vm.deleteTask
    }
  }, [_vm._m(0)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "text-danger"
  }, [_c('i', {
    staticClass: "fa fa-remove"
  }), _vm._v(" Excluir Task")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-25d26cde","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/tasks/components/BtnAcaoListaTasks.vue
// module id = 1564
// module chunks = 17